module.exports = __webpack_public_path__ + "img/inventory_forecasting.6e336574.svg";